import { Button, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

export default function Logout() {
    const { t } = useTranslation();
    const url = new URL(window.location.href);

    const handleLogoutClick = () => {
        localStorage.removeItem(process.env.REACT_APP_TOKEN_NAME ?? 'token');
        window.location.replace(url.searchParams.get('redirect') ?? '');
    }

    const handleCancelClick = () => {
        window.location.replace(url.searchParams.get('redirect') ?? '');
    }
    return (
        <div className="flex flex-col space-y-4 mt-10">
            <Typography>{t('logout_description')}</Typography>
            <div className="text-center">
                <Button className="m-2" variant="contained" onClick={handleCancelClick}>{t('cancel')}</Button>
                <Button className="m-2" onClick={handleLogoutClick}>{t('logout')}</Button>
            </div>
        </div>
    )
}
